<script setup lang="ts">
import { getCategoryRoute, getTranslatedProperty } from "@shopware/helpers";
import type { Schemas } from "#shopware";
type NavigationElement = Schemas["Category"] & {
  activeClass?: boolean;
};

const localePath = useLocalePath();
const { formatLink } = useInternationalization(localePath);

const props = defineProps<{
  navigationElementChildren: Array<NavigationElement>;
  row: any;
  disableRecursive?: boolean;
}>();

const emits = defineEmits<{
  (
    e: "updateActiveClass",
    navigationId: string,
    parentId: string | undefined
  ): void;
  (e: "focusoutLastElement", lastElement: boolean): void;
}>();

const emitUpdateActiveClass = (
  navigationId: string,
  parentId: string | undefined
) => {
  emits("updateActiveClass", navigationId, parentId);
};

const count = Math.ceil(props.navigationElementChildren.length / 3);

const start = props.row == 1 ? 0 : count * (props.row - 1);
const end = props.row != 3 ? start + count - 1 : start + count;
</script>

<template>
  <template
    v-for="(childElement, index) in navigationElementChildren"
    :key="childElement.id"
  >
    <li v-if="index >= start && index <= end && !childElement.translated?.customFields?.custom_new_and_trendy_enabled" class="mb-2">
      <NuxtLink
        :to="formatLink(getCategoryRoute(childElement))"
        :target="
          childElement.externalLink || childElement.linkNewTab ? '_blank' : ''
        "
        :class="{ 'text-pink font-semibold': childElement.activeClass }"
        class="text-base transition-colors duration-200"
        @click="emitUpdateActiveClass(childElement.id, childElement.parentId)"
      >
        {{ getTranslatedProperty(childElement, "name") }}
      </NuxtLink>
      <template
        v-if="childElement.children && childElement.children.length > 0 && !disableRecursive"
      >
        <div class="ml-4 pl-2 border-l border-gray-200 mt-2">
          <LayoutTopNavigationRecursive
            :navigation-element-children="childElement.children"
            :row="props.row"
            @update-active-class="
              emitUpdateActiveClass(childElement.id, childElement.parentId)
            "
          />
        </div>
      </template>
    </li>
  </template>
</template>

<style scoped>
/* All styles converted to Tailwind classes */
</style>
